module.exports = __webpack_public_path__ + "static/homepageBG1-4f93aac31a837980f4abbaf705f6ca25.jpg";